import React, { useCallback } from 'react';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '../../../store';
import isEqual from 'lodash/isEqual';
import { ExchangeOnlinePolicyItem } from '@Policy/utils/types';
import {
  vsPswProtectedFileActionTeamsChatSelector,
  vsPswProtectedFileActionTeamsSelector,
  vsUnscannableFileConfigSelector,
} from '@Policy/store/filters/malwareScanning';
export const useVsUnscannableFileOptions = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const setVsState = contextSelector((s) => s.setVsState);
  const { replaceFileName, replaceText, actionConfig } = contextSelector(
    vsUnscannableFileConfigSelector,
    isEqual
  );
  // local state
  const [isUnscannableFileOptionsVisible, setIsUnscannableFileOptionsVisible] =
    React.useState<boolean>(false);
  const handleUnscannableFileOptionsClose = useCallback(() => {
    setIsUnscannableFileOptionsVisible(false);
  }, []);
  return {
    isUnscannableFileOptionsVisible,
    setIsUnscannableFileOptionsVisible,
    handleUnscannableFileOptionsClose,
    setVsState,
    replaceFileName,
    replaceText,
    actionConfig,
  };
};

export const useTeamsChatUnscannableFileOptions = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state and action from store
  const replaceFileName = policySelector(
    (s) => s.tmVirusscans.vsReplacementFileNameUnscannable
  );
  const replaceText = policySelector(
    (s) => s.tmVirusscans.vsReplacementTextUnscannable
  );
  const actionConfig = contextSelector(
    vsPswProtectedFileActionTeamsChatSelector,
    isEqual
  );
  return {
    replaceFileName,
    replaceText,
    actionConfig,
  };
};

export const useTeamsUnscannableFileOptions = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state and action from store
  const replaceFileName = policySelector(
    (s) => s.tmVirusscans.vsReplacementFileNameUnscannable
  );
  const replaceText = policySelector(
    (s) => s.tmVirusscans.vsReplacementTextUnscannable
  );
  const actionConfig = contextSelector(
    vsPswProtectedFileActionTeamsSelector,
    isEqual
  );
  return {
    replaceFileName,
    replaceText,
    actionConfig,
  };
};
